import { combineReducers } from 'redux';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { Action as GradProgramAction } from '../../actions/orgDashboard/gradPrograms';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { Action as IdealistDayEventAction } from '../../actions/orgDashboard/idealistDayEvents';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { Action as IntegrationsAction } from '../../actions/orgDashboard/integrations';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { Action as ListingsAction } from '../../actions/orgDashboard/listings';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { Action as OrgAction } from '../../actions/orgDashboard/orgs';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { Action as SearchAction } from '../../actions/orgDashboard/search';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import gradPrograms from './gradPrograms';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import idealistDayEvents from './idealistDayEvents';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import integrations from './integrations';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import listings from './listings';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import orgs from './orgs';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import search from './search';

export default combineReducers<
  {
    orgs: typeof orgs;
    listings: typeof listings;
    search: typeof search;
    gradPrograms: typeof gradPrograms;
    idealistDayEvents: typeof idealistDayEvents;
    integrations: typeof integrations;
  },
  | OrgAction
  | ListingsAction
  | SearchAction
  | GradProgramAction
  | IdealistDayEventAction
  | IntegrationsAction
>({
  // @ts-expect-error ts-migrate(2322) FIXME: Type '(state: State, action: Action) => State' is ... Remove this comment to see the full error message
  orgs,
  // @ts-expect-error ts-migrate(2322) FIXME: Type '(state: State, action: Action) => State' is ... Remove this comment to see the full error message
  listings,
  // @ts-expect-error ts-migrate(2322) FIXME: Type '(state: State, action: Action) => State' is ... Remove this comment to see the full error message
  search,
  // @ts-expect-error ts-migrate(2322) FIXME: Type '(state: State, action: Action) => State' is ... Remove this comment to see the full error message
  gradPrograms,
  // @ts-expect-error ts-migrate(2322) FIXME: Type '(state: State, action: Action) => State' is ... Remove this comment to see the full error message
  idealistDayEvents,
  // @ts-expect-error ts-migrate(2322) FIXME: Type '(state: State, action: Action) => State' is ... Remove this comment to see the full error message
  integrations,
});
